import React from "react";

// Small progress ring used across the client dashboard (metrics, macros,
// readiness pods). Purely presentational — pass `gradientId` together with
// `gradientColors` for a gradient stroke, or `color` for a flat one.
const MiniRing = ({ size, pct, color, label, sublabel, fontSize, gradientId, gradientColors }) => {
  const r = size / 2 - 5;
  const c = 2 * Math.PI * r;
  const off = c - (Math.min(100, Math.max(0, pct || 0)) / 100) * c;
  const fs = fontSize || (size <= 44 ? 10 : size <= 56 ? 12 : 14);
  const strokeColor = gradientId ? `url(#${gradientId})` : color;
  return (
    <div className="mini-ring-pod">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {gradientId && gradientColors && (
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor={gradientColors[0]} />
              <stop offset="100%" stopColor={gradientColors[1]} />
            </linearGradient>
          </defs>
        )}
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="4" />
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={strokeColor} strokeWidth="4"
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={off}
          transform={`rotate(-90 ${size/2} ${size/2})`} className="ring-arc" />
        <text x={size/2} y={size/2} textAnchor="middle" dominantBaseline="central"
          fill="var(--text)" fontSize={fs} fontWeight="700">{label}</text>
      </svg>
      {sublabel && <span className="mini-ring-label">{sublabel}</span>}
    </div>
  );
};

export default MiniRing;
